import React from 'react'
import { connect } from 'react-redux';

import {
  loadApiKeys,
  createApiKey,
  deleteApiKey,
} from '../../actions/api_keys';

class ApiKeys extends React.Component {
  constructor(props) {
    super(props);

    this.createApiKey = this.createApiKey.bind(this);
    this.deleteApiKey = this.deleteApiKey.bind(this);
  }

  componentDidMount() {
    const { dispatch, user } = this.props;

    dispatch(loadApiKeys(this.props.user));
  }

  createApiKey() {
    const { dispatch, user } = this.props;

    dispatch(createApiKey(this.props.user));
  }

  deleteApiKey(token) {
    const that = this;

    return function() {
      const { dispatch, user } = that.props;

      dispatch(deleteApiKey(that.props.user.uuid, token));
    }
  }

  render() {
    if (!this.props.user || this.props.user.type !== 'machine') {
      return null;
    }

    return (
      <div className="border rounded-md overflow-hidden p-5 mb-6 shadow">
        <h3 className="font-bold col-span-6 mb-5">
          API Keys
        </h3>

        <button onClick={this.createApiKey}
          className="py-1 px-2 border border-transparent shadow-sm rounded-md
          text-white bg-green-600">

          Create API Key
        </button>

        {
          this.props.newToken &&
          <div className="mt-5 p-2 border rounded bg-gray-100">
            <div className="mt-2 p-2 bg-white border rounded break-all">
              { this.props.newToken }
            </div>
          </div>
        }


        <div className="mt-5">
          { this.props.apiKeys.map((key) => (
            <div key={key.token_hmac} className="grid grid-cols-4 my-2 text-xs border p-2">
              <div className="inline-block">
                { key.token_hmac }
              </div>
              <div className="inline-block">
                { key.expires_at }
              </div>
              <div className="inline-block">
                { key.created_at }
              </div>
              <div className="inline-block">
                <input
                  className="py-1 px-2 border border-transparent shadow-sm
                             rounded-md bg-red-600 text-white"
                  onClick={this.deleteApiKey(key.token_hmac)}
                  type="button"
                  value="Delete" />
              </div>
            </div>
          )) }
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return({
    apiKeys: state.apiKeys.data.filter((p) => p.user_id === ownProps.user.uuid),
    newToken: state.apiKeys.newToken,
  });
}

export default connect(mapStateToProps)(ApiKeys);
